<template>
  <div>
    <a href="book" v-if="display === 'list'" >
      <li>
          <div class="col-md-12">
            <div class="col-md-2">
                <subscribe :book="item"></subscribe>
                <img :title="item.Title" :src="item.CoverURL" />
            </div>
            <div class="col-md-4">
                <div class="book_slider_wrap_list">
                <div class="book_slider_name">{{item.Title}}</div>
                <div class="bookcase_history_author">{{item.Author.Name}}</div>
                  <div class="staricon_wrap" v-if="item.Rank">
                      <div class="icon" v-for="star of item.Rank.RankStar" :key="star"></div>
                  </div>
                </div>
            </div>
          </div>
      </li>      
    </a>
    <li v-if="display === 'block'">
      <subscribe :book="item"></subscribe>
      <div class="new_icon">NEW</div>
      <a class="thumb" href="#"><img :title="item.Title" :src="item.CoverURL" /></a>
      <div class="book_slider_wrap">
          <div class="book_slider_name"><a>{{item.Title}}</a></div>
          <div class="book_slider_no bookcast_no">{{item.Author.Name}}</div>
          <div class="staricon_wrap_bookcase" v-if="item.Rank">
              <div class="icon_no">{{item.Rank.RankStar}}</div>   
              <div class="icon"></div>       
          </div>                                        
      </div>
    </li>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'
import Remodal from './Remodal.vue'
import Subscribe from './Subscribe.vue'

export default {
  name: 'BookIn',
  props: ["book", "display"],
  data () {
    return {
      item: this.book
    }
  },
  methods: {
    ...user,
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  },
  components: {
    Remodal,
    Subscribe
  }
}
</script>



// WEBPACK FOOTER //
// src/BookIn.vue